export default {
    url: '',
    template: '<forms-questions-poolless-list></forms-questions-poolless-list>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/poolless/list/index.js